//TODO: need to refactor with CMS / TeleScript support

import React from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { ContentBox, ContentBoxBody, ContentBoxHead } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const RegisterVerificationErrorPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <ContentBox className='form-step step6'>
                <ContentBoxHead>Please Contact Player Services</ContentBoxHead>
                <ContentBoxBody>
                    <div className='text-center'>
                        <img src='players-club-logo.png' className='img-fluid mx-auto my-3' />
                    </div>
                    <p className='text-center'>
                        Your account could not be verified and needs manual validation via our Player Services Department.
                        <br />
                        Please contact us at 1-800-201-0108.
                    </p>
                    <p className='text-center'>
                        <Link to='/feedback#contact' className='btn theme-btn btn-danger'>
                            Contact Player Services
                        </Link>
                    </p>
                </ContentBoxBody>
            </ContentBox>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterVerificationErrorPage);
